import { Component, OnChanges, OnInit, OnDestroy, Input, Output, EventEmitter, Type } from '@angular/core';
import { ColmecWorkOrder } from '../colmec-working-order-wrapper/colmec-working-order-wrapper.component';
import { ColmecWorkingOrderStepComponent } from '../steps/colmec-working-order-step/colmec-working-order-step.component';
import { Subject, first } from 'rxjs';
import { AuthService } from 'gung-standard';

@Component({
    selector: 'colmec-working-order-buttons',
    templateUrl: './colmec-working-order-buttons.component.html',
    styleUrls: ['./colmec-working-order-buttons.component.scss'],
    standalone: false
})
export class ColmecWorkingOrderButtonsComponent implements OnChanges, OnInit, OnDestroy {
  @Input()
  currentStep: Type<ColmecWorkingOrderStepComponent>;

  @Input()
  allSteps: Type<ColmecWorkingOrderStepComponent>[];

  @Output()
  nextClicked = new EventEmitter<void | any>();

  @Output()
  prevClicked = new EventEmitter<void>();

  public prevBtnText: string;
  public nextBtnText: string;
  public isFirstStep = true;
  public isLastStep = false;
  public isUser = false;
  public isSales = false;
  public isAdmin = false;

  public unsubscribe: Subject<void> = new Subject();

  constructor(protected authService: AuthService) {}

  ngOnChanges(): void {
    this.updateData();
  }

  ngOnInit() {
    this.updateData();

    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => {
        this.isSales = roles.indexOf('SALES') > -1;
        this.isAdmin = roles.indexOf('ADMIN') > -1;
        this.isUser = roles.indexOf('USER') > -1 && !this.isSales && !this.isAdmin;
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  updateData() {
    this.isFirstStep = this.allSteps.indexOf(this.currentStep) === 0;
    this.isLastStep = this.allSteps.indexOf(this.currentStep) === this.allSteps.length - 1;
  }

  updateBtnTexts(workingOrder: ColmecWorkOrder) {
    const btnTexts = this.currentStep.prototype.getBtnTexts(workingOrder);
    this.nextBtnText = 'NEXT';
    this.prevBtnText = 'PREV';
    if (!btnTexts) {
      return;
    }

    this.nextBtnText = btnTexts.next || this.nextBtnText;
    this.prevBtnText = btnTexts.prev || this.prevBtnText;
  }
}
